import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IPlanejamentoPapelTrabalho } from 'src/app/models/planejamento-papel-trabalho.model';
import { PapeisTrabalhoService } from 'src/app/services/papeis-trabalho.service';
import { PlanejamentoService } from 'src/app/services/planejamento.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-imprimir-papeis',
  templateUrl: './imprimir-papeis.component.html',
  styleUrls: ['./imprimir-papeis.component.scss']
})
export class ImprimirPapeisComponent implements OnInit {
  idPlanejamento: number;

  model: IPlanejamentoPapelTrabalho[] = [];  

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    private papeisTrabalhoService: PapeisTrabalhoService,
    private planejamentoService: PlanejamentoService
  ) {
    this.idPlanejamento = Number(this.route.snapshot.paramMap.get('id'));
  }

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    this.carregaPapeisTrabalho();
  }

  carregaPapeisTrabalho() {
    this.planejamentoService
      .obterPapeisTrabalho(this.idPlanejamento)
      .then((res) => {
        this.model = res.dados as IPlanejamentoPapelTrabalho[];        
        console.log(this.model);
      })
      .catch((err) => {
        //this.exibirMensagemAlerta(err.mensagem.descricao);
      })
  }  

  getSigla(item: IPlanejamentoPapelTrabalho) {
    return item.sigla + "-" + (item.posicao).toString().padStart(2, "0");
  }  

  getSituacao(item: IPlanejamentoPapelTrabalho) {
    return item.sigla == "PT" ? "" : "(" + item.situacaoNome + ")";
  }

  public cancelar() {
    this.router.navigate([`planejamento/${this.idPlanejamento}/planejar`], { state: { aba: 8 }})
  }

  public print() {
    window.print();
  }

  exibeJustificativa(item: IPlanejamentoPapelTrabalho) {
    if (item.idTipoAceitavel != 2 && (item.arquivos == null || item.arquivos.length == 0)) {
      return true;
    }
    else if (item.idTipoAceitavel == 2 && this.isValidUrl(item.link) == false) {
      return true;
    }
    
    return false;
  }

  isValidUrl(value: string): boolean {
    const pattern = /^(https?:\/\/)?([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,}))(:\d+)?(\/[^\s]*)?$/;
    return pattern.test(value);
  }

}
